module.exports = __webpack_public_path__ + "img/landingpage-video-simple-mobile.a23eca83.svg";